package com.anjuros.website.templates.template2.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.MenuIcon
import com.anjuros.website.templates.template2.modules.Template2Section
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.Template2HeaderLogoStyle
import com.anjuros.website.templates.template2.styles.Template2MainTextStyle
import com.anjuros.website.templates.template2.styles.Template2NavigationItemStyle
import com.anjuros.website.templates.template2.util.Template2CompanyDetails
import com.anjuros.website.templates.template2.util.Template2Constants
import com.anjuros.website.templates.template2.util.Template2Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template2Header(onMenuCLicked:()->Unit={}) {
    Row(
        modifier = Template2HeaderLogoStyle.toModifier()
            .fillMaxWidth()
            .backgroundColor(Template2Theme.Primary.getColor())
        , horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.size(50.px).displayUntil(Breakpoint.LG)){

            MenuIcon(
                modifier = Modifier

                    .margin(left = 20.px)
                    .color(Colors.White)
                    .onClick {
                        onMenuCLicked() }
            )
        }
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
        ) {
            AnjurosLogo(
                modifier = Modifier.size(100.px),
                src = Template2Res.Image.template2_logo2,
                alt = "Website template"
            )
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                P(
                    attrs = Template2MainTextStyle.toModifier()
                        .margin(right = 20.px)
                        .fontFamily(Template2Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .color(Colors.White)
                        .fontWeight(FontWeight.Bold)

                        .toAttrs()
                ) {
                    AnjurosText(Template2CompanyDetails.CLIENTS_NAME_INFO)

                }
                Link(
                    path = "tel:${Template2Constants.CLIENTS_PHONE}",
                    modifier = Modifier.textDecorationLine(TextDecorationLine.None)

                ) {
                    P(
                        attrs = Template2MainTextStyle.toModifier()
                            .margin(right = 20.px)
                            .fontFamily(Template2Constants.FONT_FAMILY)
                            .fontSize(14.px)
                            .color(Colors.White)
                            .fontWeight(FontWeight.Bold)

                            .toAttrs()
                    ) {
                        AnjurosText(Template2CompanyDetails.CLIENTS_PHONE_INFO)

                    }
                }
            }
        }


        Row(modifier = Modifier.displayIfAtLeast(Breakpoint.LG).margin(right=30.px),
            horizontalArrangement = Arrangement.spacedBy(30.px)) {
            Template2Section.entries.toTypedArray().forEach { section ->

                Column(modifier = Template2NavigationItemStyle.toModifier()) {
                    Link(
                        modifier = Modifier
                            .align(Alignment.CenterHorizontally)
                            .textDecorationLine(TextDecorationLine.None),
                        path = section.path
                    ) {
                        P(
                            attrs = Modifier
                                .margin(topBottom = 0.px)
                                .fontFamily(Template2Constants.FONT_FAMILY)
                                .fontSize(18.px)
                                .color(Colors.White)
                                .fontWeight(FontWeight.Normal)
                                .toAttrs()
                        ) {
                            Text(LocalText(section.headerTitle))

                        }
                    }

                    Box(modifier = Modifier.id("sectionUnderline").align(Alignment.CenterHorizontally).padding(right = 30.px).width(40.px).height(2.px).backgroundColor(Colors.White))
                }

            }
        }

    }
}